module.exports = __webpack_public_path__ + "static/media/8.ded2f0a3.jpeg";